import './App.css';
import React, {useEffect, useState} from "react";
import {useHistory} from "react-router-dom";

const Login = () => {
  const [token, setToken] = useState("");
  const [showLoginForm, setShowLoginForm] = useState(false);
  const history = useHistory();

  useEffect(() => {
      sessionStorage.removeItem('reloadCount');
      // Clear any stored token from a previous session so it doesn't shadow
      // the new login if the cookie ends up missing later.
      try { localStorage.removeItem('jfd_token'); } catch (e) {}
  }, [])

  const submit = () => {
    const t = token.toLowerCase().trim();
    fetch(`/users/login?t=${t}`)
      .then(() => {
        // Mirror the new token to localStorage immediately so reloads work
        // even before /users/current re-confirms server-side.
        try { localStorage.setItem('jfd_token', t); } catch (e) {}
        history.push('/');
      })
  }

  const bigBtnStyle = {
      display: 'block',
      width: '100%',
      padding: '20px 24px',
      marginTop: 16,
      fontSize: 24,
      fontWeight: 900,
      fontStyle: 'italic',
      letterSpacing: 4,
      textTransform: 'uppercase',
      fontFamily: 'inherit',
      color: 'white',
      border: '2px solid white',
      borderRadius: 8,
      cursor: 'pointer',
      textShadow: '1px 1px 0 rgba(0,0,0,0.85)',
      boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.25), 0 3px 0 rgba(0,0,0,0.6)',
      WebkitAppearance: 'none',
      touchAction: 'manipulation',
      WebkitTapHighlightColor: 'transparent',
  };

  // Registration never closes: late arrivals scan in mid-show and get
  // dealt into the open-roster games (melee, AT votes, bargain) once the
  // operator flips them ready.
  const showChooser = !showLoginForm;

  return <div style={{display: 'flex', minHeight: '100dvh', alignItems: 'center', justifyContent: 'center', backgroundColor: '#000'}}>
      <div style={{width: "100%", textAlign: 'center'}}>
          <video
              src="logo-video.mp4"
              autoPlay
              loop
              muted
              playsInline
              style={{width: '100%', display: 'block', marginBottom: 20}}
          />
          <div style={{width: '80%', margin: '0 auto'}}>
              {showChooser ? (
                  <>
                      <button
                          style={{
                              ...bigBtnStyle,
                              background: 'linear-gradient(180deg, #1f6b3a 0%, #0c2e1a 100%)',
                              borderColor: '#5db380',
                          }}
                          onClick={() => history.push('/register')}
                      >Register</button>
                      <button
                          style={{
                              ...bigBtnStyle,
                              background: 'linear-gradient(180deg, #1a1a22 0%, #08080d 100%)',
                          }}
                          onClick={() => setShowLoginForm(true)}
                      >Log In</button>
                  </>
              ) : (
                  <>
                      <input
                          type="text"
                          placeholder="ENTER CODE WORD"
                          value={token}
                          onChange={(event) => setToken(event.target.value)}
                          onKeyDown={(e) => { if (e.key === 'Enter') submit(); }}
                          autoFocus
                          autoCapitalize="none"
                          autoCorrect="off"
                          style={{
                              width: '100%',
                              boxSizing: 'border-box',
                              padding: '18px 20px',
                              fontSize: 22,
                              fontFamily: 'inherit',
                              fontWeight: 700,
                              letterSpacing: 6,
                              textTransform: 'lowercase',
                              textAlign: 'center',
                              color: 'white',
                              background: 'rgba(255,255,255,0.04)',
                              border: '1px solid rgba(255,255,255,0.4)',
                              borderRadius: 8,
                              outline: 'none',
                              boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.08)',
                          }}
                      />
                      <button
                          style={{
                              ...bigBtnStyle,
                              background: 'linear-gradient(180deg, #1a1a22 0%, #08080d 100%)',
                          }}
                          onClick={submit}>
                          Log In
                      </button>
                      <div style={{
                          marginTop: 18,
                          fontSize: 13,
                          fontStyle: 'italic',
                          opacity: 0.6,
                          color: 'white',
                      }}>Forgot your code? Ask Cole.</div>
                      {(
                          <button
                              style={{
                                  marginTop: 16,
                                  background: 'transparent',
                                  border: 'none',
                                  color: 'white',
                                  opacity: 0.6,
                                  fontSize: 14,
                                  fontFamily: 'inherit',
                                  cursor: 'pointer',
                                  padding: 8,
                                  textDecoration: 'underline',
                              }}
                              onClick={() => setShowLoginForm(false)}
                          >← Back</button>
                      )}
                  </>
              )}
          </div>
      </div>
  </div>
}

export default Login;
